import { render, staticRenderFns } from "./ImagesModal.vue?vue&type=template&id=0bd10779&scoped=true"
import script from "./ImagesModal.vue?vue&type=script&lang=js"
export * from "./ImagesModal.vue?vue&type=script&lang=js"
import style0 from "./ImagesModal.vue?vue&type=style&index=0&id=0bd10779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd10779",
  null
  
)

export default component.exports